

module.exports = __webpack_require__.stylable.create(
    "ColorPickerbase4120213362",
    {"classes":{"root":"ColorPickerbase4120213362__root","container":"ColorPickerbase4120213362__container","wrapper":"ColorPickerbase4120213362__wrapper","label":"ColorPickerbase4120213362__label","item":"ColorPickerbase4120213362__item"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    5,
    "ColorPickerbase4120213362",
    null
);
